<template>
  <div class="tw-mt-3 tw-flex tw-gap-x-3 tw-items-center">
    <slot name="icon">
      <WdsIcon class="tw-text-gray-600 tw-flex-shrink-0" :name="iconName" :size="16" />
    </slot>
    <slot>
      <div class="tw-text-gray-900">
        {{ text }}
      </div>
    </slot>
  </div>
</template>

<script setup>
import { WdsIcon } from '@worksome/wds-components'

defineProps({
  iconName: {
    type: String,
    default: undefined,
  },
  text: {
    type: String,
    default: undefined,
  },
})
</script>
